import React from 'react'
import GlobalView from './GlobalView'
import BPTable from './BPTables'
import { useUserContext } from "../../userContext"
import "./home.css"

function Home() {
  const { user } = useUserContext()

  const UserView = () => (
    <div className="user-title-inventory">
      <h1 id='user-title'>Bienvenue {user?.firstName && user?.firstName.toUpperCase()}</h1>
      <h2>Selectionnez un BP pour commencer le contrôle</h2>
    </div>
  )

  return (
    <>
      {user && user.group === 'admin'
        ?
        <div className='home-main'>
          <GlobalView />
          <BPTable />
        </div>
        :
        <div className='home-main'>
          <UserView />
          <BPTable />
        </div>
      }
    </>
  )
}

export default Home